import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

interface YardiPropertyIdEntry {
  yardiPropertyId: string
}

export const getYardiPropertyIdsQueryKey = (buildingId?: number) => [
  'useGetYardiPropertyIds',
  buildingId,
]

export const getYardiPropertyIds = async (buildingId: number, signal?: AbortSignal) => {
  const response = await authAPI.get<YardiPropertyIdEntry[]>('/yardi/property-id', {
    params: { buildingId },
    signal,
  })
  return response.data
}

export const useGetYardiPropertyIds = (buildingId: number | undefined, enabled: boolean) => {
  return useQuery({
    enabled: enabled && !!buildingId,
    queryFn: ({ signal }) => getYardiPropertyIds(buildingId!, signal),
    queryKey: getYardiPropertyIdsQueryKey(buildingId),
  })
}
